/* @flow weak */
import * as actions from './actions';
import * as loginActions from '../login/actions';
import {Record} from '../transit';
import {fromJS, Map} from 'immutable';

const State = Record({
    error: null,
    location: null,
    online: false,
    storageLoaded: false,
}, 'app');

const appReducer = (state = new State(), action) => {
    // This is how we can handle all async actions rejections.
    if (action.type.endsWith('_ERROR')) {
        const {errors} = action.payload;
        return state.set('error', fromJS(errors));
    }

    switch (action.type) {

        case actions.SET_ERROR_OFFLINE: {
            return state.set('error', Map({'0': action.payload.error}))
        }

        case loginActions.API_LOGOUT:
        case actions.REMOVE_ERRORS: {
            return state.set('error', null);
        }

        case actions.APP_OFFLINE:
            return state.set('online', false);

        case actions.APP_ONLINE:
            return state.set('online', true);

        case actions.APP_SET_LOCATION:
            return state.set('location', action.payload.location);

        case actions.APP_STORAGE_LOAD:
            if(action.payload.useMigrationData) {
                location.href = '/'; // redirect to root to remove query parameter and prevent duplicate migrations on reload
            }
            return state.set('storageLoaded', true);

        default:
            return state;

    }
};

export default appReducer;



// WEBPACK FOOTER //
// ./src/common/app/reducer.js